/**
 * 换购更多活动专享页
 */
import React, { useEffect, useMemo } from 'react'
import { observer } from 'mobx-react'
import { IonContent, IonFooter, IonHeader, IonModal } from '@ionic/react'
import { ActivityProductItem } from '@pages/menu/modal/SearchModal/components'
import { CartBar } from '@pages/menu/components'
import { getHistoryNew, setDocumentTitle } from '@utils'
import './index.scss'
import { cartMobx, discountMobx } from 'restaurant'

interface IProps {
  reject?: () => void;
  resolve?: (product: any) => void;
}

const OrderSwapBuyModal: React.FC<IProps> = (props) => {
  const { reject, resolve } = props
  const history = getHistoryNew()
  const { orderSwapBuyActivity, orderSwapBuyActivityProducts } = discountMobx
  const { orderSwapBuyProductNoToCntMap } = cartMobx.cartResult

  // 判断能否整单换购
  const canOrderSwapBuy = useMemo(() => {
    return orderSwapBuyActivity?.surplusCnt && !orderSwapBuyActivity?.buyAgainFee
  }, [orderSwapBuyActivity])

  useEffect(() => {
    const title = document.title
    setDocumentTitle(i18n.t('menu.activityVip'))

    return () => {
      setDocumentTitle(title)
    }
  }, [])

  const handleClose = () => {
    props.reject()
  }

  const handleChooseProduct = (product) => {
    props.resolve(product)
  }

  return (
    <IonModal
      cssClass='order-swap-buy-modal'
      isOpen
      showBackdrop
      swipeToClose
      backdropDismiss={false}
    >
      <IonHeader>
        <div className='act-desc'>
          <div className='go-back' data-cypid='orderSwapBuyModalClose' onClick={() => handleClose()}>
            <i className='iconfont icon-BACK-12x'></i>
          </div>
          <div className='header'>
            <h4>{i18n.t('menu.fullOff.partinProduct', { name: orderSwapBuyActivity?.activityName })}</h4>
            {i18n.t('menu.activityExplain')}
          </div>
        </div>
      </IonHeader>
      <IonContent>
        <div className='bpm-content'>
          {
            orderSwapBuyActivityProducts.length ? (
              <div className='bpm-list'>
                {
                  orderSwapBuyActivityProducts.map(item => (
                    <ActivityProductItem
                      key={item.no}
                      cnt={orderSwapBuyProductNoToCntMap[`${item.no}`]}
                      product={item}
                      isOrderSwapBuy
                      isAddProduct
                      disabled={!canOrderSwapBuy}
                      onClick={handleChooseProduct}
                    />
                  ))
                }
              </div>
            ) : (
              <div className='empty-info'>
                <p>{i18n.t('menu.noProductsCanDiscount')}</p>
              </div>
            )
          }
        </div>
      </IonContent>
      <CartBar onClick={() => handleClose()} />
    </IonModal>
  )
}

export default observer(OrderSwapBuyModal)
